import { render, staticRenderFns } from "./ServiceClient.vue?vue&type=template&id=90e7d668&scoped=true"
import script from "./ServiceClient.vue?vue&type=script&lang=js"
export * from "./ServiceClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e7d668",
  null
  
)

export default component.exports